import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Alert, Button, Input, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as elements from '../data/Elements';
import * as paths from '../data/Paths';
import * as Studies from '../store/Studies';
import * as StudySites from '../store/StudySites';
import * as utility from '../data/Utility';

class LinkStudiesInternal extends React.Component {
    constructor(props) {
        super(props);

        const createAccount = utility.propCheck(props.createAccount, false);
        const createSite = utility.propCheck(props.createSite, false);
        const siteId = utility.propCheck(props.siteId, "");
        const siteName = utility.propCheck(props.siteName, "");
        const studies = utility.propCheck(props.studies, []);
        const userName = utility.propCheck(props.userName, "");
        const forAccount = (
            createAccount ||
            userName !== ""
        );
        let dynaIds = utility.propCheck(props.dynaIds, []);

		if ( dynaIds === null || dynaIds === undefined ) {
			dynaIds = [];
		}

        this.state = {
            createAccount: createAccount,
            createSite: createSite,
            forAccount: forAccount,
            siteId: siteId,
            siteName: siteName,
            dynaIds: dynaIds,
            studies: studies,
            userName: userName
        };

        this.checkIfActive = this.checkIfActive.bind(this);
        this.getListGroup = this.getListGroup.bind(this);
        this.handleSelectClick = this.handleSelectClick.bind(this);
        this.handleDynaValue = this.handleDynaValue.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    checkIfActive(study) {
        return this.state.studies.map(function (e) { return e.id; }).indexOf(study.id);
    }


    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);

		(async () => {
			await this.props.studiesDispatch.getAll();
		})().then(() => {
			const allStudies = this.props.studiesState.all;

			if ( ! allStudies ) {
				return;
			}
			this.buildDynaIdValues();
		});

		this.props.studySitesDispatch.getAll();
    }

	buildDynaIdValues() {
        const allStudies = this.props.studiesState.all;

		if ( ! allStudies ) {
			return;
		}

		let allDynaIds = this.state.dynaIds;

		for ( var idx = 0 ; idx < allStudies.length ; idx++ ) {
			const study = allStudies[idx];

			const studySites = this.props.studySitesState.all;
			const mySiteId = this.state.siteId;

            var siteStudyRec = null;
            if (studySites != null) {
                siteStudyRec = studySites.find(function (s) { return (s.study.id === study.id) && (s.site.id === mySiteId) });
            }
			const idSiteStudy = siteStudyRec && siteStudyRec.clinicalId_Dynavision;

			if ( idSiteStudy > 0 ) {
				allDynaIds[idx] = { studyId: study.id, dynaId: idSiteStudy };

			} else {
				allDynaIds[idx] = { studyId: study.id, dynaId: "" };
			}
		}

		this.setState( { dynaIds: allDynaIds } );
	}

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSelectClick();
        }
    }

    handleDynaValue(idx, theStudyId, value) {
		var allDynaIds = this.state.dynaIds.slice(); // Make a copy of the dynaIds first.
		allDynaIds[idx] = { studyId: theStudyId, dynaId: value }; // Update it with the modified value.
		this.setState( { dynaIds: allDynaIds } ); // Update the state.
    }

    getListGroup(allStudies) {
        const listItems = allStudies.map((study,idx) => {
            const active = this.checkIfActive(study) >= 0;

			const disabled = "";
			const readOnly = false;
			const type = elements.inputTypes.text;
			const inlineStyle = { marginLeft: "10px", marginRight: "50px", width: "100px" };

            return (
                <ListGroupItem key={study.id} active={active} tag="button" title={study.name} action onClick={this.handleStudySelected.bind(this, study, idx)}>
                    <div className="tab">
						<div className="lblDynaSiteStudyId">
							Dyna-Vision ID:
						</div>
						<Input className="input btnDynaSiteStudyId" key={"key"+idx} disabled={disabled} id={"dynaSiteStudyId"+idx} onChange={(e) => this.handleDynaValue(idx, study.id, e.target.value)} onKeyDown={this.handleKeyDown} readOnly={readOnly} type={type} value={this.state.dynaIds.length > idx ? this.state.dynaIds[idx].dynaId : 0} style={inlineStyle} />
                        <Input className="input" type="checkbox" checked={active} readOnly />{' '}
                        {study.name}
                    </div>
                </ListGroupItem>
            );
        });

        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    handleSelectClick() {
        var pathname = "";
        var state = null;

        if (this.state.forAccount) {
            if (this.state.createAccount) {
                pathname = paths.createAccount;
            }
            else {
                pathname = paths.account;
            }
            state = {
                create: this.state.createAccount,
                linkReturn: true,
                studies: this.state.studies,
                userName: this.state.userName
            };
        }
        else {
            if (this.state.createSite) {
                pathname = paths.createSite;
            }
            else {
                pathname = paths.site;
				/* TODO: store the possible Dyna-Vision number associated with this Site/Study */
            }

            state = {
                create: this.state.createSite,
                linkReturn: true,
                siteId: this.state.siteId,
                dynaIds: this.state.dynaIds,
                studies: this.state.studies
            };
        }

        this.props.history.push({
            pathname: pathname,
            state: state
        });
    }

    handleStudySelected(study,idx) {
        const active = this.checkIfActive(study);
        const studies = this.state.studies;

        if (active >= 0) {
            studies.splice(active, 1);
        }
        else {
            studies.push(study);
        }

        this.setState({
            studies: studies
        });
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching)) {
            this.props.studySitesDispatch.getAll();
        }
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const allStudies = this.props.studiesState.all;
        var error = false;
        var listGroup = null;
        var message = "";
        const select = "Select";
        var siteName = this.state.siteName;
        var userName = this.state.userName;
        var title = "";

        if (siteName === "") {
            siteName = "{empty}";
        }
        if (userName === "") {
            userName = "{empty}";
        }
        if (this.state.forAccount) {
            title = ` to account user name '${userName}'`;
        }
        else {
            title = ` to site name '${siteName}'`;
        }
        
        if (allStudies != null &&
            allStudies.map != null) {
            listGroup = this.getListGroup(allStudies);
        }
        else {
            error = true;
            message = "Error retrieving studies.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Link Studies<small>{title}</small></h1>
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <div className="gap" />
                {listGroup}
                <div className="button-gap">
                    <Button className="button" title={select} onClick={this.handleSelectClick}>{select}</Button>
                </div>
            </div>
        );
    }
}

const LinkStudiesConnect = withRouter(connect(
    state => ({
        studySitesState: state.studySites,
        accountsState: state.accounts,
        studiesState: state.studies
    }),
    dispatch => ({
        studySitesDispatch: bindActionCreators(StudySites.actionCreators, dispatch),
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch)
    })
)(LinkStudiesInternal));

export default class LinkStudies extends React.Component {
    render() {
        var createAccount = false;
        var createSite = false;
        var siteId = "";
        var siteName = "";
        var studies = [];
        var dynaIds = [];
        var userName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            createAccount = utility.propCheck(propsState.createAccount, createAccount);
            createSite = utility.propCheck(propsState.createSite, createSite);
            siteId = utility.propCheck(propsState.siteId, siteId);
            siteName = utility.propCheck(propsState.siteName, siteName);
            studies = utility.propCheck(propsState.studies, studies);
            dynaIds = utility.propCheck(propsState.dynaIds, dynaIds);
            userName = utility.propCheck(propsState.userName, userName);
        }

        return (
            <ErrorBoundary>
                <LinkStudiesConnect createAccount={createAccount} createSite={createSite} siteId={siteId} siteName={siteName} studies={studies} dynaIds={dynaIds} userName={userName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LinkStudies.js